import React from "react";

export default function Contact() {
  return <h1> Page Not Found. </h1>;
}
